import { AlignRight } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconAlignRight12Line = createIcon(AlignRight, 12, "Line");
export const IconAlignRight16Line = createIcon(AlignRight, 16, "Line");
export const IconAlignRight20Line = createIcon(AlignRight, 20, "Line");
export const IconAlignRight24Line = createIcon(AlignRight, 24, "Line");
export const IconAlignRight32Line = createIcon(AlignRight, 32, "Line");
export const IconAlignRight48Line = createIcon(AlignRight, 48, "Line");
export const IconAlignRight64Line = createIcon(AlignRight, 64, "Line");
